import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RepoBusinessState } from './repo-business.reducer';

export const selectRepoBusinessState = createFeatureSelector<RepoBusinessState>('repoBusiness');

export const selectRepoBusinesses = createSelector(
  selectRepoBusinessState,
  (state) => state.loadBusiness == false ? null : state.repoBusinesses
);

export const selectPositions = createSelector(
  selectRepoBusinessState,
  (state) => state.positions
);

export const selectAllContacts = createSelector(
  selectRepoBusinessState,
  state => state.loadAllContacts == false ? null : state.ids.map(id => state.entities[id])
);

export const selectContactsByBusinessId = (businessId: number) =>
  createSelector(
    selectRepoBusinessState,
    state => state.loadContacts === false
      ? null
      : Object.values(state.entities).filter(c =>
        c.repoBusiness && c.repoBusiness.repoBusinessId === businessId
      )
  );


export const selectRepoBusinessLoading = createSelector(
  selectRepoBusinessState,
  (state) => state.loading
);

export const selectRepoBusinessError = createSelector(
  selectRepoBusinessState,
  (state) => state.error
);

export const selectRepoBusinessSuccess = createSelector(
  selectRepoBusinessState,
  (state) => state.success
);
